import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV2';
import { LicenseInfo } from '@mui/x-license';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router';

import { config } from '#config.ts';
import { ThemeModeProvider } from '#lib/ThemeProvider';
import { queryClient } from './lib/react-query/client.ts';
import { createRouter } from './routes/router.tsx';

import './styles.css';

/**
 * Perfectly fine to be hard-coded.
 * @see https://github.com/mui/mui-x/issues/12308#issuecomment-1976362879
 * @see https://github.com/mui/mui-x/issues/12308#issuecomment-1978327132
 * @see https://mui.com/x/introduction/licensing/#environment-variable-with-next-js
 */
LicenseInfo.setLicenseKey(config.MUI_LICENSE_KEY);

const router = createRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeModeProvider>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeModeProvider>
      </LocalizationProvider>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  </StrictMode>
);
